module.exports = __webpack_public_path__ + "static/luminor-8a1461d14c19b90c0fd14fe4bb521068.png";